export class ContactInfoCustomFieldHeaderResultDto {
  fieldName: string;
  caption: string;
}
